module.exports = __webpack_public_path__ + "static/media/lápiz.790ae05b.png";